<app-loader *ngIf="stateService.appLoading$ | async"></app-loader>
<router-outlet></router-outlet>